export default __webpack_public_path__ + "static/contact-65a33abb6b732474786ad2336496591d.png";